export interface LeadOption {
  value: number;
  label: string;
}

export interface CreateAccountState {
  /** companies tab → true (typeId fixed to 1); internal-projects tab → false */
  isCompany: boolean;
  name: string;
  leadOption: LeadOption | null;
  color: string | null;
  /** only meaningful when !isCompany: 2 = Internal, 3 = Private */
  typeId: number | null;
  emailValid: boolean;
  /** local part the user typed (without @suffix) */
  emailValue: string;
}

export interface CreateAccountParams {
  color: string;
  createdBy: number;
  project: string;
  projectManagerId: number;
  email: string;
  typeId: number;
}

export const canSubmit = (s: CreateAccountState): boolean => {
  const baseOk = Boolean(
    s.name && s.leadOption?.value && s.color && s.emailValid && s.emailValue
  );
  if (!baseOk) return false;
  if (!s.isCompany && !s.typeId) return false;
  return true;
};

/** `email` is the full address (local part + @EMAIL_SUFFIX), built by the caller. */
export const buildCreateParams = (
  s: CreateAccountState,
  createdBy: number,
  email: string
): CreateAccountParams => ({
  color: s.color as string,
  createdBy,
  project: s.name,
  projectManagerId: s.leadOption!.value,
  email,
  typeId: s.isCompany ? 1 : (s.typeId as number),
});
